import type { IconData } from '@stacksjs/iconify-core'

export const ch1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"red\" d=\"M0 0h512v512H0z\"/><g fill=\"#fff\"><path d=\"M96 208h320v96H96z\"/><path d=\"M208 96h96v320h-96z\"/></g></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default ch1x1
